//import { get, post } from './../utils/fetch.js'
import axios from '@/utils/api.request'

//接口列表
//获取文章列表
//export function getNewsList(param) {
//  return post('/api', param)
//}
export const getNewsList = ({lang,type,current}) => {
	const data = {
		lang,
		type,
		current,
		func: 'getNewsList'
	}
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}
//根据id获取文章内容
export const getNewsById = ({id}) => {
	const data = {
		id,
		func: 'getNewsById'
	}
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}


// WEBPACK FOOTER //
// ./src/api/article.js